export default function isValidToken(token) {
	return typeof token === 'string' && token !== '' && token !== null && token !== undefined;
}
